import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";
import {HTTP_METHOD, PROCESS_NAME} from "../constants/EWasteApiPaths";

/**
 * Shared helper for e-waste search APIs that return paginated entity lists.
 * Handles the gateway call, status check, metric logging, and response shaping.
 *
 * @param {string} resourcePath API resource path.
 * @param {Object} requestBody Request body to send.
 * @param {string} metricProcessName Metric process name for logging.
 * @param {string} subProcess Sub-process name for logging.
 * @returns {Promise<{success: boolean, count: number, from: number, size: number, entities: Array}>}
 */
export async function callEWasteSearchApi(resourcePath, requestBody, metricProcessName, subProcess) {
    const startTime = Date.now();
    const request = {
        resourcePath,
        httpMethod: HTTP_METHOD.POST,
        processName: PROCESS_NAME.OCULUS,
        requestBody
    };

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, subProcess, true);
            return {
                success: true,
                count: (response.data && response.data.count) || 0,
                from: (response.data && response.data.from) || 0,
                size: (response.data && response.data.size) || 0,
                entities: (response.data && response.data.entities) || []
            };
        }
        logOperationalMetric(startTime, metricProcessName, subProcess, false);
        return {success: false, count: 0, from: 0, size: 0, entities: []};
    } catch (error) {
        logOperationalMetric(startTime, metricProcessName, subProcess, false);
        return {success: false, count: 0, from: 0, size: 0, entities: []};
    }
}



// WEBPACK FOOTER //
// ./src/commons/api/EWasteApiHelper.js